import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './DailyrentReviewContainer.css';
import { AuthorContainer } from '../ReviewsItem/Author';
import { getAnswersByReviewId, getReviewById } from '../../selectors/reviews';
import { ButtonLink } from '../../components/ButtonLink';
import { setAnswersVisibility } from '../../actions/reviews';
import { NewAnswerButtonContainer } from '../NewAnswerButton';
import { ExpandableBubbleContainer } from '../ExpandableBubbleContainer';

const MAX_MESSAGE_BUBBLE_HEIGHT = 400;

interface IDailyrentReviewContainerProps {
  reviewId: string;
}

export const DailyrentReviewContainer = ({ reviewId }: IDailyrentReviewContainerProps) => {
  const dispatch = useDispatch();

  const review = useSelector(getReviewById(reviewId));
  const answers = useSelector(getAnswersByReviewId(reviewId));

  const hasAnswers = !!review.answersCount;
  /** Показываем ответы на отзывы, если они есть и если они развернуты */
  const showAnswers = hasAnswers && review.areAnswersOpened;
  /** Показываем кнопки под отзывом, если есть ответы или если можно ответить на отзыв */
  const showReviewControls = hasAnswers || review.showAnswerButton;

  const onAnswerVisibilityClick = React.useCallback(() => {
    dispatch(setAnswersVisibility({ reviewId, state: !review.areAnswersOpened }));
  }, [reviewId, review.areAnswersOpened, answers.length]);

  return (
    <article className={styles['root']}>
      <AuthorContainer {...review} />
      {(review.comment.positive || review.comment.negative) && (
        <ExpandableBubbleContainer
          className={styles['message-bubble']}
          positive={review.comment.positive}
          negative={review.comment.negative}
          maxHeight={MAX_MESSAGE_BUBBLE_HEIGHT}
        />
      )}
      {showReviewControls && (
        <div className={styles['controls']}>
          {hasAnswers && (
            <ButtonLink onClick={onAnswerVisibilityClick} className={styles['answers-visibility-button']}>
              {review.areAnswersOpened ? 'Скрыть' : review.answersCount}
            </ButtonLink>
          )}
          {review.showAnswerButton && <NewAnswerButtonContainer targetId={reviewId} type="review" />}
        </div>
      )}
      {showAnswers && (
        <ul className={styles['answers']}>
          {answers.map(answer => (
            <li key={answer.id} data-testid="DailyrentReviewReply">
              <AuthorContainer user={answer.user} date={answer.date} />
              <ExpandableBubbleContainer
                className={styles['message-bubble']}
                text={answer.comment.text}
                maxHeight={MAX_MESSAGE_BUBBLE_HEIGHT}
              />
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};
